export const DATAHUB_ROW_HEIGHT = 52;
export const DATAHUB_LIST_ROW_HEIGHT = 60;
export const DATAHUB_SPACING_LG = '24px';

export const DATAHUB_SELECTED_ITEMS_MAX_ROWS = 6;
export const DATAHUB_ITEM_DETAILS_MAX_ROWS = 6.1; // Display the last row cut-in-half to indicate scrolling
export const DATAHUB_ACTION_BUTTON_WIDTH = 147;
